import { render, staticRenderFns } from "./ListGoals.vue?vue&type=template&id=22a28934"
import script from "./ListGoals.vue?vue&type=script&setup=true&lang=js"
export * from "./ListGoals.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports